module.exports = __webpack_public_path__ + "img/clip.6237abe1.svg";